import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminFacilityProcesses } from '@/api/(admin)/facility-processes';
import type { AdminFacilityProcess } from '@/api/(admin)/facility-processes/types';
import type { FacilityProcessesQueryInput } from '../-types';
import {
  buildFacilityProcessesQs,
  toFacilityProcessesParams,
} from '../-utils/listParams';

/** Prefix for every cache entry, so one invalidation clears the list. */
export const adminFacilityProcessesQueryKey = [
  'admin',
  'facility-processes',
] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function adminFacilityProcessesQueryOptions(
  input: FacilityProcessesQueryInput,
) {
  const params = toFacilityProcessesParams(input);
  return queryOptions({
    queryKey: [...adminFacilityProcessesQueryKey, 'list', params] as const,
    queryFn: () =>
      fetchAdminFacilityProcesses(buildFacilityProcessesQs(params)),
  });
}

export function useAdminFacilityProcesses(input: FacilityProcessesQueryInput) {
  const query = useQuery(adminFacilityProcessesQueryOptions(input));

  const rows: AdminFacilityProcess[] = query.data?.data ?? [];

  return {
    ...query,
    rows,
    totalCount: query.data?.metadata.pagination.total ?? 0,
  };
}
